import base from "/Users/lone/Desktop/monochrome/images/google.svg?svg";
import { getParams, mergeSvgAttributes } from "svg-merge-attributes";
export default mergeSvgAttributes(base, getParams("size=22"));